"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var classnames_1 = __importDefault(require("classnames"));
var link_module_scss_1 = __importDefault(require("./link.module.scss"));
/**
 * ### Production-ready Checklist:
 * * (✔) implementation of component approved by design team;
 * * (✔) has storybook, covered with stories and documentation;
 * * (✔) has tests: test every prop, every state and every interaction that's js related;
 * * (see apps/test/unit/componentLibrary/LinkTest.jsx)
 * * (?) passes accessibility checks;
 *
 * ###  Status: ```Ready for dev```
 *
 * Design System: Link Component.
 * Used for internal or external links. Shortcut for general <a> HTML tag (with DSCO styles applied).
 * Can be opened in new tab, have custom onClick, also can be disabled.
 */
var Link = function (_a) {
    var children = _a.children, id = _a.id, className = _a.className, external = _a.external, openInNewTab = _a.openInNewTab, _b = _a.href, href = _b === void 0 ? '#' : _b, disabled = _a.disabled, onClick = _a.onClick, _c = _a.size, size = _c === void 0 ? 'm' : _c, _d = _a.type, type = _d === void 0 ? 'primary' : _d;
    return (react_1.default.createElement("a", __assign({ className: (0, classnames_1.default)(link_module_scss_1.default.link, link_module_scss_1.default["link-".concat(type)], link_module_scss_1.default["link-".concat(size)], className), href: !disabled ? href : undefined, id: id, onClick: !disabled ? onClick : undefined, rel: openInNewTab || external ? 'noopener noreferrer' : undefined, target: (openInNewTab || undefined) && '_blank' }, (disabled ? { 'aria-disabled': true } : {})), children));
};
exports.default = Link;
